module.exports = __webpack_public_path__ + "static/ss.6a38c5c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/tst/ss.png
// module id = 288
// module chunks = 39732927749384 277036769636407